<template>
    <div class="col-12 col-sm-7 toggle-route-wrapper">
        <div class="row align-items-center">
            <div class="col-12 col-xl-6 col-xxl-7">
                <h5 class="d-none d-sm-block fs-5 mb-1">Select a tyre fitting method</h5>
                <p v-if="toggledHomeDelivery == false" class="d-none d-sm-inline-block">You can choose mobile or garage fitting at the next step</p>
                <p v-else class="d-none d-sm-inline-block">Tyres delivered straight to your door</p>
            </div>
            <div class="col-12 col-xl-6 col-xxl-5">
                <div class="form-check form-switch d-inline-block ps-0 ps-sm-2 ps-xl-5">
                    <label class="form-check-label float-start cursor-pointer" :class="{ 'fw-bold': toggledHomeDelivery == false }" for="flexSwitchCheckChecked">Fully fitted</label>
                    <input class="form-check-input float-start mx-2 cursor-pointer" type="checkbox" role="switch" id="flexSwitchCheckChecked" @change="toggleRoute((toggledHomeDelivery == true ? 1 : 0))"  v-model="toggledHomeDelivery" :checked="toggledHomeDelivery">
                    <label class="form-check-label float-start cursor-pointer" :class="{ 'fw-bold': toggledHomeDelivery == true }" for="flexSwitchCheckChecked">Home delivery</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    export default {
        props: ['parentHomeDelivery'],
        emits: ['routeToggled'],
        mixins: [url_filters],
        components: {

        },
        data() {
            return {
                toggledHomeDelivery: this.parentHomeDelivery
            }
        },
        methods: {
            toggleRoute: function(data) {
                let vm = this;
                axios.post('/ajax/toggle_home_delivery_route/' + data)
                .then(response => {
                    vm.$emit('routeToggled', data);
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    .toggle-route-wrapper {
        h5 {
            font-size: 17px;
            margin: 0;
        }
        .form-switch .form-check-input {
            background-color: #00a68f;
            border-color: #00a68f;
            background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
        }
        .form-switch .form-check-input:focus {
            border-color: rgba(0, 0, 0, 0.25);
            border: none;
            outline: 0;
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
            background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
        }
        .form-switch .form-check-input:checked {
            background-color: #00a68f;
            border-color: #00a68f;
            border: none;
            background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
        }
    }
</style>